import { API } from "constants/envs";
import { encryptRSA } from "tools/encryption";

export const postGenerateLink = async (typeDoc: string, docNumber: string, isYounger: boolean) => {
  const url = `${API}/patient/generate-link`;

  const body = JSON.stringify({ payload: encryptRSA(JSON.stringify({ typeDoc, docNumber, isYounger })) });

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "*",
      "Authorization": `Bearer ${localStorage.getItem('token') || ''}`
    },
    body,
  });

  const info = response.json();
  return info;
}
